import { render } from "./FilteredArticlesPage.vue?vue&type=template&id=a8d119f0&scoped=true"
import script from "./FilteredArticlesPage.vue?vue&type=script&lang=js"
export * from "./FilteredArticlesPage.vue?vue&type=script&lang=js"

import "./FilteredArticlesPage.vue?vue&type=style&index=0&id=a8d119f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d119f0"]])

export default __exports__